module.exports = __webpack_public_path__ + "img/score.be368af4.png";